import { Component, OnInit } from '@angular/core';
import {YmlService} from "../yml.service";
import {YmlModel} from "../../model/yml.model";
import {ActivatedRoute, Params, Router} from "@angular/router";

@Component({
    selector: 'app-yml-editor',
    templateUrl: './yml-editor.component.html',
    styleUrls: ['./yml-editor.component.scss'],
    standalone: false
})
export class YmlEditorComponent implements OnInit {

  yml: YmlModel;
  newItem = true;

  constructor(
    private service: YmlService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.route.params.subscribe((params:Params) => {
      let id = params['id'] ? params['id'] : null;
      if (!id) {
        return this.router.navigate(['/data/yml']);
      } else {
        if (id === 'new') {
          this.newItem = true;
          this.yml = new YmlModel();
        } else {
          this.newItem = false;
          this.fetchItem(id);
        }
      }
    })
  }

  fetchItem(id){
    this.service.getItem(id).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      if (resp.id) {
        this.yml = new YmlModel(resp);
      }
    })
  }

  handleDelete() {
    this.service.deleteItem(this.yml.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Successfully deleted");
        return this.router.navigate(['/data/yml']);
      }
    })
  }

  deleteItem() {
    this.service.confirmAction("Are you sure you delete this?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.handleDelete()
      }
    })
  }

  saveItem() {
    if (!this.yml.isValid()) {
      return this.service.notiService.open("Fill every required field.");
    }
    this.service.saveItem(this.yml).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      if (resp.id) {
        this.yml = new YmlModel(resp);
      }
      this.service.notiService.open("Saved");
    })
  }

}
